//import axios from 'axios';

import axios from "axios";
import { setCurrentUser,getCurrentUser } from '../../utils/index'

const state={
    currentUser: null
};

const getters={
    currentUser: state => state.currentUser,
};

const mutations={
    setUser(state, payload) {
        state.currentUser = payload
    },
};

const actions={
    login({ commit }, payload) {
           if(payload){
            setCurrentUser(payload)
            commit('setUser', payload)
           }
    }
        
}




export default{
    state,
    getters,
    actions,
    mutations
}



